export const CHILD_TO_PARENT_FEATURES: Record<string, string> = {
  orders: 'commerce',
  products: 'commerce',
  abonded_carts: 'commerce',
  payments: 'commerce',
  store_reports: 'commerce',
  invoices: 'commerce',
  scheduling: 'appointments',
  time_slots: 'appointments',
  meeting_links: 'appointments',
  whatsapp_reminders: 'appointments',
};

export function isFeatureEnabledWithFallback(
  enabledFeatures: Record<string, boolean> | null | undefined,
  featureKey: string | null | undefined,
): boolean {
  if (!featureKey) return true;
  const features = enabledFeatures || {};
  if (features[featureKey] === true) return true;
  const parentKey = CHILD_TO_PARENT_FEATURES[featureKey];
  return !!parentKey && features[parentKey] === true;
}
